import { ReactNode } from 'react';
import { Stack } from '../../../design-system/stack/stack';

type OAuthConnectionsTableWrapperProps = {
  title: string;
  children: ReactNode;
};

export const OAuthConnectionsTableWrapper = ({ title, children }: OAuthConnectionsTableWrapperProps) => {
  return (
    <Stack>
      <h3 className="text-sm font-medium leading-6 tracking-tight text-black">{title}</h3>

      {children}
    </Stack>
  );
};
